module.exports = __webpack_public_path__ + "img/1.d14b1d22.jpg";